"use strict";

define('evisions/redactor.plugins/docstore.redactor.plugin',['rs/models/docstore', 'rs/modals/upload/upload.controller'], function (DocStore, UploadModal) {
  if (typeof window.RedactorPlugins === 'undefined') window.RedactorPlugins = {};
  window.RedactorPlugins.docstore = {
    init: function init() {
      this.buttonAdd('file', 'Add an attachment', _.bind(this.uploadFileClicked, this));
    },
    uploadFileClicked: function uploadFileClicked() {
      UploadModal.show({
        documentId: this.opts.documentId,
        multiple: this.opts.multipleUpload || false
      }).bind(this).spread(function (files, links) {
        var attachmentText = '',
          attachmentURL = '',
          self = this;
        function createLinkElement(text, url) {
          var link = $(document.createElement("a"));
          link.text(text).attr('href', url).attr("target", "_blank").attr('title', text).addClass("redactor-inline-attachment");
          self.insertHtml('&nbsp;' + link.get(0).outerHTML + '&nbsp;');
        }
        for (var i = 0, len = files.length; i < len; i++) {
          attachmentText = files[i].fileName;
          attachmentURL = files[i].getAbsoluteURL();
          createLinkElement(attachmentText, attachmentURL);
        }
        for (var j = 0, len = links.length; j < len; j++) {
          attachmentText = links[j].getDisplayName();
          attachmentURL = links[j].getUrl();
          createLinkElement(attachmentText, attachmentURL);
        }
      });
    }
  };
  return RedactorPlugins;
});

